module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG05a24546742e3f0a8b1580fcedcd75e5.05a24546.png";